import React, { useEffect, useState } from "react";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import APIs from "../redux/apiUrl";
import LoaderScreen from "./loader/loaderScreen";
import { FaInstagram, FaFacebookF, FaPinterestP } from "react-icons/fa";
import { SiTiktok } from "react-icons/si";

// Fallback reel images
const fallbackImages = [
  "/assets/img/other/instagram1.webp",
  "/assets/img/other/instagram2.webp",
  "/assets/img/other/instagram3.webp",
  "/assets/img/other/instagram4.webp",
  "/assets/img/other/instagram5.webp",
  "/assets/img/other/instagram6.webp",
  "/assets/img/other/instagram7.webp",
];

// Detect icon from the link
const getSocialIconFromLink = (link) => {
  if (!link) return <FaInstagram className="w-6 h-6 text-white" />;

  const url = link.toLowerCase();

  if (url.includes("instagram.com")) {
    return <FaInstagram className="w-6 h-6 text-white" />;
  } else if (url.includes("facebook.com")) {
    return <FaFacebookF className="w-6 h-6 text-white" />;
  } else if (url.includes("pinterest.com")) {
    return <FaPinterestP className="w-6 h-6 text-white" />;
  } else if (url.includes("tiktok.com")) {
    return <SiTiktok className="w-6 h-6 text-white" />;
  } else {
    return <FaInstagram className="w-6 h-6 text-white" />; 
  }
};

const SwiperSection = () => {
  const [reels, setReels] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchReels = async () => {
      try {
        setLoading(true);
        const response = await APIs.get("/get_all_reels/1/10");
        const reelsData = response.data?.data?.docs;
  
        // ✅ check if data is empty
        if (reelsData && reelsData.length > 0) {
          setReels(reelsData);
        } else {
          // Use fallback
          setReels(
            fallbackImages.map((img, index) => ({
              _id: `fallback-${index}`,
              reel_image: img,
              link: "https://www.instagram.com/gloriousevidenceofficial/",
            }))
          );
        }
      } catch (error) {
        // In case of error, also use fallback
        setReels(
          fallbackImages.map((img, index) => ({
            _id: `fallback-${index}`,
            reel_image: img,
            link: "https://www.instagram.com/gloriousevidenceofficial/",
          }))
        );
      } finally {
        setLoading(false);
      }
    };
    fetchReels();
  }, []);
  

  return (
    <div className="instagram__section section--padding pt-0">
      <div className="container-fluid p-0">
        {loading ? (
          <LoaderScreen />
        ) : (
          <Swiper
            spaceBetween={10}
            slidesPerView={7}
            autoplay={{ delay: 5000 }}
            navigation={true}
            loop={true}
            pagination={false}
            breakpoints={{
              0: { slidesPerView: 2 },
              375: { slidesPerView: 2 },
              575: { slidesPerView: 3 },
              767: { slidesPerView: 4 },
              991: { slidesPerView: 5 },
              1199: { slidesPerView: 7 },
            }}
            modules={[Pagination, Navigation, Autoplay]}
            className="swiper-wrapper mt-8"
          >
            {reels.map((reel) => (
              <SwiperSlide key={reel._id} className="swiper-slide">
                <div className="relative overflow-hidden group">
                  <a
                    className="block"
                    target="_blank"
                    rel="noopener noreferrer"
                    href={reel.link}
                  >
                    <img
                      className="w-full h-[250px] object-cover transition-transform duration-300 group-hover:scale-105"
                      src={reel.reel_image}
                      alt="Social Media Reel"
                    />

                    <div className="absolute top-1/2 left-1/2 w-14 h-14 bg-red-500 flex items-center justify-center rounded-full text-secondary transition-all duration-300 transform -translate-x-1/2 -translate-y-1/2 scale-0 group-hover:scale-100 group-hover:bg-secondary group-hover:text-white">
                      {getSocialIconFromLink(reel.link)}
                    </div>
                  </a>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        )}
      </div>
    </div>
  );
};

export default SwiperSection;
